import { get, post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getApplications = async (payload) => {
  const builder = new UrlBuilder(`/get-applications`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getApplicationDetails = async (payload) => {
  const builder = new UrlBuilder(`/get-application-info`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const saveQueryResponse = async (payload) => {
  const builder = new UrlBuilder(`/save-query-response`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getUserInfo = async () => {
  const builder = new UrlBuilder(`/auth/get-profile`);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getRecentApplicantInfo = async () => {
  const builder = new UrlBuilder(`/get-recent-applicant`);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const sentApplicationReportViaEmail = async (payload) => {
  const builder = new UrlBuilder(`/send-report-email`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
